/**
 * How the signed-in user is named in the header and the mobile drawer.
 *
 * The login response carries firstName / lastName / username / email — never
 * `name` — so the drawer, which read `user.name`, always showed the generic
 * "User". Prefer the person's name, then the username, then the email's
 * local part; `fallback` only when there is nothing at all.
 */
export function userDisplayName(user, fallback = '') {
  if (!user) return fallback;
  const full = [user.firstName, user.lastName].map((p) => (p == null ? '' : String(p).trim())).filter(Boolean).join(' ');
  if (full) return full;
  if (user.name && String(user.name).trim()) return String(user.name).trim();
  if (user.username && String(user.username).trim()) return String(user.username).trim();
  if (user.email) return String(user.email).split('@')[0];
  return fallback;
}

/**
 * Letters for the avatar: first + last initial for Latin names; one letter for
 * Arabic / Hebrew, where two initials read as a word ("مدير المركز" → "ما").
 */
export function userInitials(user, fallback = 'U') {
  const name = userDisplayName(user);
  if (!name) return fallback;
  const parts = name.split(/\s+/).filter(Boolean);
  if (/[֐-ۿ]/.test(parts[0][0])) return parts[0][0];
  const letters = parts.length >= 2 ? parts[0][0] + parts[parts.length - 1][0] : parts[0][0];
  return letters.toUpperCase();
}
